import React, { PureComponent } from 'react';
import { DLModal } from 'appSrc/components/Shards';
import { PrimaryButton } from 'appSrc/components/UI';
import style from './styles/style.module.css';


class ProductInsertModal extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            step: 1,
        };
        this.newDelta = {};
    }
    stepTwo = ( elClass ) => {
        this.newDelta.className = elClass;
        this.setState( { step: 2 } );
    }
    submit = ( product ) => {
        this.newDelta.dataId = product.desireid;
        this.newDelta.dataTitle = product.title;

        this.props.onSubmit( this.newDelta );
    }


    render() {
        const { step } = this.state;
        const { products } = this.props;

        return (
            <DLModal title='Insert Product'
            className={ style.productInsertModal }
            closeHandler={ this.props.closeModal }>
                <div>
                    { step == 1 &&
                    <div>
                        <h3>Style:</h3>
                        <div className={ style.formatOptions }>
                            <PrimaryButton label='Exploded Card'
                            onClick={ () => { this.stepTwo( 'exploded-product-card' ); } } />
                            <PrimaryButton label='Review Focused Card'
                            onClick={ () => { this.stepTwo( 'review-focused-product-card' ); } } />
                        </div>
                    </div>
                    }
                    { step == 2 &&
                    <div className={ style.productSelect }>
                        <h3>Product:</h3>
                        { products.map( ( product ) => (
                            <div className={ style.productOption }
                            key={ 'ipm-select-' + product.desireid }
                            onClick={ () => { this.submit( product ); } }>{ product.title }</div>
                        ) ) }
                    </div>
                    }
                </div>
            </DLModal>
        );
    }
}
ProductInsertModal.defaultProps = {
    products: [],
    onSubmit: () => {},
};

export default ProductInsertModal;
